<script lang="ts">
    import {onMount} from "svelte";
    import {Input, Label} from "flowbite-svelte";

    export let value;

    export let label = null;
    export let id = 'input-' + (Math.random() + 1).toString(36).substring(2)

    let localValue;
    let day = '';
    onMount(() => {
        if(typeof value === 'undefined'){
            value = ''
        }
        if(typeof value.value !== 'undefined'){
            localValue = value.value.replace(/\d{4}-\d{2}-\d{2}\s/,'')
            day = value.value.replace(/\s\d{2}:\d{2}:\d{2}/,'')
        }
        localValue = typeof value.value !== 'undefined' ? value.value.replace(/\d{4}-\d{2}-\d{2}\s/,'') : value;
        localValue = localValue.trim()
    })

</script>
{#if label}
    <Label for="{id}">{label}</Label>
{/if}
<Input {id} type="time" bind:value={localValue} on:input={() => value=day+' '+localValue + ':00'} />
